B<template>
  <div class="atividades-sacsolicitacoes ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="5">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <!-- condicional para exibir o botão planilha-->
        <b-col cols="2">
          <br />
          <input type="file" @change="handleFileUpload" />
        </b-col>

        <b-col cols="2">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            block
            @click="(carregando = true), postFuncionarios()"
          >
            Gravar
          </b-button>
        </b-col>

        <b-col cols="3" class="mb-0">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Registro ou Tipo de solicitação ou palavras na solicitação"
          ></b-form-input>
        </b-col>

        <LoadingModal v-if="isLoadingFuncionario" />
      </b-row>
    </b-form>

    <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>
      <b-card
        class="ml-2"
        style="width: 33rem"
        border-variant="primary"
        header="QUANTIDADE DE FUNCIONÁRIOS"
        header-bg-variant="primary"
        header-text-variant="white"
        align="center"
      >
        <b-card-text>
          <h2>
            {{ planilhaFuncionario ? planilhaFuncionario.length : 0 }}
          </h2>
        </b-card-text>
      </b-card>
    </b-card-group>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>

    <b-progress :max="planilhaFuncionario.length" :value="progressValue">
      <template v-slot:label>{{ progressValue.toFixed(2) }}%</template>
    </b-progress>

    <!--tbl de dados -->
    <b-table
      id="resolicitante"
      small
      hover
      striped
      sticky-header="756px"
      :items="itemsFiltered"
      :fields="fieldsRecibos"
    >
      <!-- Exibindo a condição com base no valor -->
      <template v-slot:cell(C)="data">
        {{ getConditionLabel(data.item["C  "]) }}
      </template></b-table
    >
  </div>
</template>


    </b-table>
      
      <!--  MODAL SOLICITÇÕES  -->
      <div>        
    <b-modal id="modal-multi-1" cancel-title="Fechar" ok-title="Gravar" @ok="postFuncao()"  size="xl" :title="`Solicitação Nº.: ${sacsolicitacao.id_solicitacao != null ? sacsolicitacao.id_solicitacao :'-' }`"     no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>

            <b-row>
              <input  id="id-sac" type="hidden" v-model="sacsolicitacao.id_solicitacao" />

              <b-col cols="1" class="mt-2  pr-4" >
                  <b-form-group label="" label-for="tabela-foto">
                    <b-img                         height="120" width="78" 
                        class="mb-5" 
                        v-model="sacsolicitacao.foto_url"                         
                        v-bind="mainProps" rounded alt="Foto"
                        
                        :src="sacsolicitacao.foto_url"
                    >
                    </b-img>
                  </b-form-group>                  
              </b-col>
              
              <b-col cols="2" class="mt-5">
                <label for="input-live">Registro</label> 
                <b-form-input  id="resolicitante" v-model="sacsolicitacao.re_solicitante" readonly placeholder="" class="mb-3"></b-form-input>
              </b-col>

              <b-col cols="3" class="mt-5">
                <label for="input-live">Nome</label> 
                <b-form-input  id="resolicitante" v-model="sacsolicitacao.nome" readonly placeholder="" class="mb-3"></b-form-input>
              </b-col>

              <b-col cols="3" class="mt-5">
                <label for="input-live">Função</label>
                <b-form-input id="resolicitante" v-model="sacsolicitacao.funcao_solicitante" readonly placeholder=""></b-form-input>              
              </b-col>

            <b-col sm="3" class="mt-5">
              <label for="input-resolicitante">Parecer</label> 
              <div>                    
                <b-form-select   id="resolicitante"               
                  v-model="sacsolicitacao.id_status"  
                  :options="statuss"
                  class="mb-3"
                  text-field="status"                            
                >                
                </b-form-select>
              </div>
            </b-col> 

            </b-row> 

            <b-row>
              <b-col sm="3">
                <label for="textarea-small">Justificativa</label>  
              </b-col>
              <b-col sm="12">
                <b-form-textarea
                  id="id-pecas" 
                  v-model="sacsolicitacao.justificativa" 
                  readonly            
                  size="sm"
                  class="mb-3"
                  placeholder="Pergunta do colaborador"
                ></b-form-textarea>
              </b-col>
            </b-row> 

            <!-- Tratativas -->                
          <div class="d-flex justify-content-center mb-3">
            <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
          </div>    
          <!--tbl de dados -->



            <b-row>
              <b-col sm="12">
                
                <label for="textarea-small">Parecer da solicitação:</label>  

            
                
              </b-col>
              <b-col sm="12">
                <b-form-textarea                   
                  id="id-obs"
                  v-model="sacsolicitacao.parecer"
                  size="sm"      
                  placeholder="Digite o parecer para o colaborador"
                  
                ></b-form-textarea>
              </b-col>
            </b-row>

            <b-row>
              <b-col class="mb-3 mt-3 ml-5" >
                <div>
                  <b-img v-if="sacsolicitacao.file==='true'" :src="sacsolicitacao.file"  width="600" height="600"></b-img>
                </div>                              
              </b-col>
            </b-row>             
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

  </div>  

</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import * as XLSX from "xlsx";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "SacSolicitacao",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valores = [];

      valores = this.planilhaFuncionario.filter((item) => {
        // Verifica se item.FUNCAO existe e é uma string
        const cod = item.FUNCAO ? String(item.FUNCAO) : ""; // Se FUNCAO for undefined ou null, converte para string vazia

        // Converte tanto o valor de busca quanto o valor de FUNCAO para minúsculas
        return cod.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });

      return valores;
    },
  },

  data: function () {
    return {
      planilhaFuncionario: [],
      funcao: {},
      isLoadingFuncionario: false, // Controle de carregamento
      progressValue: 0, // Valor da barra de progresso
      mode: "save",
      carregando: false,
      atualizando: false,
      empresa: {},
      empresas: [], // [] lista
      value_empresa: [], // [this.empresas],
      value_filial: [],
      value_status: [],
      filial: {},
      filiais: [], // [] lista
      //value_filial:[],// [] lista

      status: {},
      statuss: [], // [] lista

      permissoes: [],
      permissao: {},

      sacsolicitacao: {}, // [] lista
      sacsolicitacoes: [], // [] lista
      pedidoferias: [], // implantado 08/07/2023
      sacT: {}, // [] lista
      sacsolicitacoestratativa: [], // [] lista
      search: "",

      value_id_area: "",

      fieldsRecibos: [
        { key: "EMP ", label: "Filial", sortable: true },
        { key: "N.REG ", label: "Registro", sortable: true },
        { key: "NOME DO FUNCIONARIO ", label: "Nome", sortable: true },
        { key: "CHAPA ", label: "Chapa", sortable: true },
        { key: "FUNCAO ", label: "Função", sortable: true },
        { key: "C.P.F. ", label: "CPF", sortable: true },

        {
          key: "NASCIMENTO ",
          label: "Data nascimento",
          sortable: true,
          formatter: (value, key, itemsFiltered) => {
            // Garantir que a data seja interpretada corretamente como 'DD/MM/YYYY'
            return moment(itemsFiltered["NASCIMENTO "], "DD/MM/YYYY")
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },

        {
          key: "ADMISSAO ",
          label: "Admissão",
          sortable: true,
          formatter: (value, key, itemsFiltered) => {
            // Garantir que a data seja interpretada corretamente como 'DD/MM/YYYY'
            return moment(itemsFiltered["ADMISSAO "], "DD/MM/YYYY")
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },

        {
          key: "DESLIGAMEN ",
          label: "Demissão",
          sortable: true,
          formatter: (value, key, itemsFiltered) => {
            // Garantir que a data seja interpretada corretamente como 'DD/MM/YYYY'
            return moment(itemsFiltered["DESLIGAMEN "], "DD/MM/YYYY")
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },

        { key: "C ", label: "Condição", sortable: true },
        { key: "HB  ", label: "Horas base", sortable: true },
      ],
      //////// defeitos da corretiva
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();

      this.isLoadingFuncionario = true;

      reader.onloadstart = () => {
        this.progressValue = 0;
      };

      reader.onprogress = (e) => {
        if (e.lengthComputable) {
          this.progressValue = (e.loaded / e.total) * 100;
        }
      };

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "array" }); // Usando 'array' em vez de 'binary'

        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(sheet);
        this.planilhaFuncionario = jsonData;

        this.isLoadingFuncionario = false;
      };

      reader.readAsArrayBuffer(file); // Usando readAsArrayBuffer para ler o arquivo
    },

    getConditionLabel(value) {
      if (value === 0) {
        return "Ativo";
      } else if (value === 1) {
        return "Demitido";
      } else {
        return "Afastado"; // Pode adicionar outras condições aqui, conforme necessário
      }
    },

    loadEmpresas() {
      let corpo = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.post(url, corpo).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    postFuncionarios() {
      // Criação do corpo da requisição
      this.progressValue = 0;
      this.isLoadingFuncionario = true;
      let corpo = {
        id_empresa:
          this.value_empresa.length > 0
            ? `${[this.value_empresa.map((e) => e.id_empresa)]}`
            : `${[this.user.id_empresa]}`,
        id_grupo: `${[this.user.id_grupo_empresa]}`,
        funcionario_id: `${this.user.id_funcionario}`,
        psg: `${this.user.psg}`,
        sistema: 1,
        funcionarios: [], // Aqui vamos armazenar o array de funcionários
      };

      // Preenchendo o array de funcionários
      // JB UTILIZE O PROGRAMA VBP0213
      // campos selecionados   :  1,2,4,5,6,12,36,37,40,42,70

      this.planilhaFuncionario.forEach((funcionario) => {
        console.log("barra" + this.progressValue);
        corpo.funcionarios.push({
          filial_id: funcionario["EMP "].trim(), // Remover espaços em branco
          registro: funcionario["N.REG "].trim(), // Remover espaços em branco
          nome: funcionario["NOME DO FUNCIONARIO "].trim(), // Remover espaços em branco
          chap: funcionario["CHAPA "].trim(), // Remover espaços em branco
          funcao: funcionario["FUNCAO "].trim(), // Remover espaços em branco
          cpf: funcionario["C.P.F. "].trim(), // Remover espaços em branco
          dt_admissao: funcionario["ADMISSAO "].trim()
            ? moment(funcionario["ADMISSAO "].trim(), "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : null, // Remover espaços em branco
          dt_nascimento: funcionario["NASCIMENTO "].trim()
            ? moment(funcionario["NASCIMENTO "].trim(), "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : null, // Remover espaços em branco
          dt_demissao: funcionario["DESLIGAMEN "].trim()
            ? moment(funcionario["DESLIGAMEN "].trim(), "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : null, // Remover espaços em branco
          horas_base: funcionario["HB  "].trim(), // Remover espaços em branco
          id_situacao: funcionario["C "].trim(), // Remover espaços em branco
          /*
            
            "funcionario_erp_id": typeof funcionario.REGISTRO  ? funcionario.REGISTRO.trim() : null,  // Verifica se é string antes de usar .trim()
            "empresa_erp_id": funcionario.EMPRESA ? this.funcionario.EMPRESA.trim() : null  // Se EMPRESA for null/undefined, atribui ''
            */
        });
      });

      // URL do endpoint
      const url = `${baseApiUrl}/folha/importacao/funcionario`;

      // Enviando a requisição POST com o array de funcionários
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess(); // Mensagem de sucesso
          this.isLoadingFuncionario = false;
          // this.reset()  // Limpar os objetos e valores, se necessário
        })
        .catch(showError); // Em caso de erro
    },

    loadCarregaSac(planilhaFuncionario) {
      this.funcao = { ...planilhaFuncionario };
    },

    reset() {
      this.planilhaFuncionario = "";
    },

    limparFiltro() {
      this.search = "";
    },
  },

  watch: {
    // Watcher que detecta alterações no valor de progressValue
    progressValue(newValue) {
      // Quando progressValue mudar, a barra de progresso será atualizada automaticamente
      //console.log(`Progresso: ${newValue}%`);
    },
  },

  mounted() {
    this.loadEmpresas();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.9em;
}

#re-nome {
  font-size: 0.9em;
}

#funcao {
  font-size: 0.9em;
}

#re-solicitante {
  font-size: 0.9em;
  font-style: inherit;
}

#parecer {
  font-size: 0.9em;
}

#rfilancamentos {
  font-size: 0.9em;
  text-align: center;
}

#resolicitante {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}
</style>